/*
  Vibranet — proposta di lingua in base al paese scelto in un modulo.

  Sui <select data-vb-country-lang>: se il paese scelto parla una lingua diversa da quella della pagina,
  una finestra propone di passare a quella lingua (o all'inglese, se la lingua del paese non c'e' sul sito).
  "Resta" non ripropone la finestra per quel paese nella sessione. I dati del modulo restano: il modulo
  B2B salva la bozza in sessionStorage e la ripristina nella pagina della nuova lingua.
  Testi e lingue disponibili arrivano dal Liquid (snippet vibranet-language-suggest).
*/
(function () {
  const dialog = document.querySelector('[data-vb-lang-suggest]');
  const form = document.getElementById('VibranetLangSuggestForm');
  const dataNode = document.getElementById('VibranetLangSuggestI18n');
  if (!dialog || !form || !dataNode || typeof dialog.showModal !== 'function') return;

  let I18N;
  try {
    // il filtro t restituisce testo con entita' HTML: qui serve testo puro
    const decoder = document.createElement('textarea');
    I18N = JSON.parse(dataNode.textContent);
    Object.keys(I18N).forEach((key) => {
      if (typeof I18N[key] === 'string') {
        decoder.innerHTML = I18N[key];
        I18N[key] = decoder.value;
      }
    });
  } catch (error) {
    return;
  }

  const root = (code) => String(code || '').toLowerCase().split('-')[0];
  const current = I18N.current;
  const byRoot = new Map((I18N.available || []).map((code) => [root(code), code]));

  /* Lingue di ciascun paese, in ordine di preferenza (codici radice). Paesi non elencati: inglese. */
  const COUNTRY_LANGS = {
    IT: ['it'], SM: ['it'], VA: ['it'],
    DE: ['de'], AT: ['de'], LI: ['de'],
    FR: ['fr'], MC: ['fr'], LU: ['fr', 'de'], BE: ['nl', 'fr'],
    ES: ['es'], PT: ['pt'], NL: ['nl'], PL: ['pl'], CZ: ['cs'], HU: ['hu'],
    GR: ['el'], CY: ['el'],
    IE: ['en'], MT: ['en'], GB: ['en'], US: ['en'], AU: ['en'], NZ: ['en'],
    CA: ['en', 'fr'], CH: ['de', 'fr', 'it'],
    BR: ['pt'], AO: ['pt'], MZ: ['pt'],
    MX: ['es'], AR: ['es'], CL: ['es'], CO: ['es'], PE: ['es'], VE: ['es'], EC: ['es'], UY: ['es'], PY: ['es'],
    BO: ['es'], CR: ['es'], PA: ['es'], DO: ['es'], GT: ['es'], HN: ['es'], SV: ['es'], NI: ['es'], PR: ['es'],
  };
  /* Il menu "extra UE" usa come valore il nome inglese del paese (all_country_option_tags di Shopify). */
  const NAME_TO_CODE = {
    Italy: 'IT', 'San Marino': 'SM', 'Vatican City': 'VA', Germany: 'DE', Austria: 'AT', Liechtenstein: 'LI',
    France: 'FR', Monaco: 'MC', Luxembourg: 'LU', Belgium: 'BE', Spain: 'ES', Portugal: 'PT', Netherlands: 'NL',
    Poland: 'PL', Czechia: 'CZ', 'Czech Republic': 'CZ', Hungary: 'HU', Greece: 'GR', Cyprus: 'CY',
    Ireland: 'IE', Malta: 'MT', 'United Kingdom': 'GB', 'United States': 'US', Australia: 'AU', 'New Zealand': 'NZ',
    Canada: 'CA', Switzerland: 'CH', Brazil: 'BR', Angola: 'AO', Mozambique: 'MZ',
    Mexico: 'MX', Argentina: 'AR', Chile: 'CL', Colombia: 'CO', Peru: 'PE', Venezuela: 'VE', Ecuador: 'EC',
    Uruguay: 'UY', Paraguay: 'PY', Bolivia: 'BO', 'Costa Rica': 'CR', Panama: 'PA', 'Dominican Republic': 'DO',
    Guatemala: 'GT', Honduras: 'HN', 'El Salvador': 'SV', Nicaragua: 'NI', 'Puerto Rico': 'PR',
  };

  const STORAGE_KEY = 'vbLangSuggestDismissed';
  const dismissed = () => {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      return [];
    }
  };
  const remember = (code) => {
    try {
      const list = dismissed();
      if (!list.includes(code)) list.push(code);
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {}
  };

  const displayName = (code, inLanguage) => {
    try {
      return new Intl.DisplayNames([inLanguage], { type: 'language' }).of(code);
    } catch (error) {
      return code;
    }
  };
  const fill = (template, values) => String(template || '').replace(/\[(\w+)\]/g, (match, key) => (key in values ? values[key] : match));

  function button(label, primary, onClick) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'vbx-btn ' + (primary ? 'vbx-btn--primary' : 'vbx-btn--ghost');
    b.textContent = label;
    b.addEventListener('click', onClick);
    return b;
  }

  /* "Vedi in tedesco (Deutsch)": il nome nella lingua della pagina e, tra parentesi, nella lingua stessa.
     Tutto in un solo span: il pulsante e' un flex e separerebbe i pezzi di testo. */
  function switchLabel(b, code) {
    const name = displayName(root(code), current);
    const own = displayName(root(code), root(code));
    const [before, after = ''] = String(I18N.switch || '[language]').split('[language]');
    const label = document.createElement('span');
    const endonym = document.createElement('span');
    endonym.lang = code;
    endonym.textContent = own || name;
    label.append(before);
    if (name && own && name.toLowerCase() !== own.toLowerCase()) label.append(name + ' (', endonym, ')');
    else label.append(endonym);
    label.append(after);
    b.replaceChildren(label);
  }

  function suggest(countryCode, countryName) {
    if (!countryCode || dismissed().includes(countryCode)) return;
    const currentRoot = root(current);
    let targets = (COUNTRY_LANGS[countryCode] || []).map((code) => byRoot.get(code)).filter(Boolean);
    let fallback = false;
    if (!targets.length) {
      // la lingua del paese non c'e' sul sito: si propone l'inglese
      targets = byRoot.has('en') ? [byRoot.get('en')] : [];
      fallback = true;
    }
    // gia' in una lingua adatta a quel paese: niente finestra
    if (!targets.length || targets.some((code) => root(code) === currentRoot)) return;

    dialog.querySelector('[data-vb-lang-suggest-title]').textContent = I18N.title;
    dialog.querySelector('[data-vb-lang-suggest-text]').textContent = fill(fallback ? I18N.text_fallback : I18N.text, { country: countryName });
    const actions = dialog.querySelector('[data-vb-lang-suggest-actions]');
    actions.innerHTML = '';
    targets.forEach((code, index) => {
      const b = button('', index === 0, () => {
        form.querySelector('[name="locale_code"]').value = code;
        dialog.close();
        form.submit();
      });
      switchLabel(b, code);
      actions.appendChild(b);
    });
    actions.appendChild(button(fill(I18N.stay, { language: displayName(currentRoot, current) }), false, () => {
      remember(countryCode);
      dialog.close();
    }));
    dialog.onclose = null;
    dialog.oncancel = () => remember(countryCode);
    dialog.showModal();
  }

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.hasAttribute('data-vb-country-lang')) return;
    const value = select.value;
    if (!value || value === 'OTHER') return;
    const code = /^[A-Z]{2}$/.test(value) ? value : NAME_TO_CODE[value] || 'ZZ';
    const option = select.selectedOptions[0];
    suggest(code, option ? option.textContent.trim() : value);
  });
})();
